<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="homeworkManagers"
        sort-by="category"
        class="elevation-1"
        :loading="$apollo.queries.homeworkManagers.loading"
        loading-text="Lütfen bekleyiniz"
        show-expand
        :expanded.sync="expanded"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <ApolloQuery :query="homeworkQuery" :variables="{homeworkManagerId: item.id}" :update="updateHomeworkQuery" >
            <template v-slot="{ result: { loading, error, data } }">
              <!-- Loading -->
              <div v-if="loading" class="loading apollo">Yükleniyor...</div>

              <!-- Error -->
              <div v-else-if="error" class="error apollo">Bir hata oluştu</div>

              <!-- Result -->
              <div v-else-if="data" class="result apollo">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left">
                        Tarih
                      </th>

                      <th v-for="student in students" :key="student.id" class="text-left">
                        {{student.user.name}}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(homeworksInDate, date) in data"
                        :key="date"
                    >
                      <td>{{ date }}</td>
                      <td v-for="(homework,i) in homeworksInDate" :key="i">
                        <v-simple-checkbox
                            v-model="homework.done"
                            disabled
                        ></v-simple-checkbox>
                      </td>


                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>

              </div>

              <!-- No result -->
              <div v-else class="no-result apollo">Sonuç yok</div>


            </template>

          </ApolloQuery>
        </td>
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>ÖDEVLER</v-toolbar-title>
          <v-divider
              class="mx-4"
              inset
              vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
              >Ekle</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.name" label="Ad"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.category" label="Kategori"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.eventSummary" label="Açıklama"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-switch v-model="editedItem.daily" label="Günlük ödev"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-dialog
                          ref="dialog"
                          v-model="dateRange"
                          :return-value.sync="editedItem.range"
                          persistent
                          width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="editedItem.range"
                              label="Tarih"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editedItem.range"
                            scrollable
                            range
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="primary"
                              @click="dateRange = false"
                          >
                            İptal
                          </v-btn>
                          <v-btn
                              text
                              color="primary"
                              @click="$refs.dialog.save(editedItem.range)"
                          >
                            Kaydet
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-autocomplete multiple v-model="editedItem.students" :items="students" item-text="user.name" item-value="id" label="Öğrenciler"></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">İptal</v-btn>
                <v-btn color="blue darken-1" text @click="save">Kaydet</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.daily="{ item }">
        <v-simple-checkbox
            v-model="item.daily"
            disabled
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.students="{ item }">
        <v-select
            :items="item.students"
            item-text="user.name"
            item-value="id"
        ></v-select>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <p>Ödev bulunamadı</p>
      </template>
    </v-data-table>
    <my-snackbar ref="snackbar"/>
  </div>

</template>

<script>
import {HOMEWORK_MANAGERS} from '@/graphql/queries'
import {CreateHomeworkManager, DeleteHomeworkManager} from '@/graphql/mutations/homeworkManager'
import MySnackbar from "@/components/mySnackbar";
import gql from "graphql-tag";
import groupBy from "@/utils/groupBy";


const STUDENT_QUERY = gql`
      query($id: ID) {
        teacher(id: $id) {
          classrooms{
            studentClassroom{
              id
              user{
                name
              }
            }
          }
        }
      }`

const HOMEWORK_QUERY = gql`
      query($homeworkManagerId: ID) {
        homeworks(homeworkManagerId: $homeworkManagerId){
          time
          done
          student{
            id
          }
        }

      }`

export default {
  components: {MySnackbar},

  data: () => ({
    dialog: false,
    dateRange: false,
    expanded: [],
    homeworkQuery: HOMEWORK_QUERY,
    headers: [
      {
        text: 'Ad',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Kategori', value: 'category' },
      { text: 'Açıklama', value: 'eventSummary' },
      { text: 'Günlük', value: 'daily' },
      { text: 'Başlangıç', value: 'start' },
      { text: 'Bitiş', value: 'end' },
      { text: 'Öğrenci', value: 'students' },
      { text: 'Actions', value: 'actions', sortable: false },
      { text: '', value: 'data-table-expand' },
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      name: '',
      category: '',
      eventSummary: '',
      start: '',
      end: '',
      range: [],
      daily: false,
      students: []
    },
    defaultItem: {
      id: null,
      name: '',
      category: '',
      eventSummary: '',
      start: '',
      end: '',
      range: [],
      daily: false,
      students: []
    },
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Ekle' : 'Düzenle'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  apollo: {
    homeworkManagers: {
      query: HOMEWORK_MANAGERS,
      variables () {
        return {
          teacherId: this.$store.getters.userCls.id,
        }
      },
      error(error) {
       this.$refs.snackbar.raiseError(error.message)
      },
    },
    students: {
      query: STUDENT_QUERY,
      variables(){
        return {
          id: this.$store.getters.userCls.id,
        }
      },
      update: data => data.teacher.classrooms.reduce((acc,c) => acc.concat(c.studentClassroom), [])
    },
  },

  methods: {

    updateHomeworkQuery : (data) => groupBy(data.homeworks, 'time'),

    editItem (item) {
      this.editedIndex = this.homeworkManagers.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.start = new Date(this.editedItem.start)
      this.editedItem.end = new Date(this.editedItem.end)
      this.dialog = true
    },

    async deleteItem (item) {
      const index = this.homeworkManagers.indexOf(item)
      confirm('Silmek istediğinize emin misiniz?') && await this.deleteHomeworkManager(index, item)
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async save () {
      await this.addHomeworkManager()
      this.close()
    },

    async addHomeworkManager () {

      if(this.editedItem.range.length === 1){
        this.editedItem.start = this.editedItem.end = this.editedItem.range[0]
      }
      else{
        // hangi gün küçükse o start olsun
        if(this.editedItem.range[1] > this.editedItem.range[0]){
          this.editedItem.start = this.editedItem.range[0]
          this.editedItem.end = this.editedItem.range[1]
        }
        else{
          this.editedItem.start = this.editedItem.range[1]
          this.editedItem.end = this.editedItem.range[0]
        }
      }


      await this.$apollo.mutate({
        mutation: CreateHomeworkManager,
        variables: {
          name: this.editedItem.name,
          category: this.editedItem.category,
          eventSummary: this.editedItem.eventSummary,
          start: this.editedItem.start,
          end: this.editedItem.end,
          daily: this.editedItem.daily,
          students: this.editedItem.students,
          teacherId: this.$store.getters.userCls.id
        },


        update: (store, { data: { createHomeworkManager } }) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: HOMEWORK_MANAGERS, variables: {teacherId: this.$store.getters.userCls.id,} })
          // Add our tag from the mutation to the end
          data.homeworkManagers.push(createHomeworkManager.homeworkManager)
          // Write our data back to the cache.
          store.writeQuery({ query: HOMEWORK_MANAGERS, variables: {teacherId: this.$store.getters.userCls.id,}, data })

        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    },

    async deleteHomeworkManager (index, item) {
      await this.$apollo.mutate({
        mutation: DeleteHomeworkManager,
        variables: {
          id: item.id
        },
        update: (store,) => {
          // Read the data from our cache for this query.
          const data = store.readQuery({ query: HOMEWORK_MANAGERS, variables: {teacherId: this.$store.getters.userCls.id,} })
          // Add our tag from the mutation to the end
          data.homeworkManagers.splice(index, 1)
          // Write our data back to the cache.
          store.writeQuery({ query: HOMEWORK_MANAGERS, variables: {teacherId: this.$store.getters.userCls.id,}, data })

        },
      }).catch((error) => {
        // Error
       this.$refs.snackbar.raiseError(error.message)
      })
    }


  },
}
</script>

